//#region src/surfaces/extension-points.ts
/**
* An extension point id: the owner's slug (the `appId` grammar), a `/`, a lowercase base, then `.v`
* and its major, `admin-app/user-picker.v1`. The owner part is `SURFACE_USE_APP_PATTERN` without its
* anchors and the name part is `SURFACE_NAME_PATTERN` without its anchors; a test holds both equal.
* Callers check {@link EXTENSION_POINT_ID_MAX_LENGTH} first, so a match runs over at most 96
* characters. The base admits no `/`, so an id holds exactly one.
*/
const EXTENSION_POINT_ID_PATTERN = "^[a-z][a-z0-9-]*[a-z0-9]/[a-z][a-z0-9-]*\\.v[1-9][0-9]{0,3}$";
/** The longest extension point id, checked before {@link EXTENSION_POINT_ID_PATTERN} (D4). */
const EXTENSION_POINT_ID_MAX_LENGTH = 96;
/** The two extension point kinds (D6): `slot`, a place a root shell provides; `surface`, a definition an embedded surface implements. Frozen. */
const EXTENSION_POINT_KINDS = Object.freeze(["slot", "surface"]);
/** How a slot is filled (D8): `item`, typed data the root renders; `surface`, an embedded surface the root mounts. Frozen. */
const SLOT_FILL_KINDS = Object.freeze(["item", "surface"]);
/** The most `extensionPoints[]` rows one `app.json` declares. */
const MAX_EXTENSION_POINTS_PER_APP = 64;
/** The most point ids one surface lists in each of `implements`, `fills` and `slots`, per list. */
const MAX_SURFACE_POINT_REFS = 32;
/** The longest `description` of one extension point. */
const EXTENSION_POINT_DESCRIPTION_MAX_LENGTH = 512;
//#endregion
export { EXTENSION_POINT_DESCRIPTION_MAX_LENGTH, EXTENSION_POINT_ID_MAX_LENGTH, EXTENSION_POINT_ID_PATTERN, EXTENSION_POINT_KINDS, MAX_EXTENSION_POINTS_PER_APP, MAX_SURFACE_POINT_REFS, SLOT_FILL_KINDS };

//# sourceMappingURL=extension-points.js.map